import { SavedFilterInterface } from '../../../interfaces/saved-filter.interface';

export class OpenModalSaveFilterAction {
    public static readonly type = '[JobsPlacements] Open modal save filter action';

    constructor(public filter: SavedFilterInterface) { }
}
